<template lang="pug">
.campaign-dashboard(v-loading="loading")
  .campaign-dashboard__taskList
    .campaign-dashboard__list-summary-container
      el-row(:gutter="20" style="margin: 0 -10px")
        el-col(:span="8")
          dashboard-total-count-card(
            :count="overview.total_count"
            :title="$t('项目总数量')"
            :icon="'icon-xiangmuzongshu'"
          )
        el-col(:span="8")
          dashboard-total-count-card(
            :count="overview.opening_count "
            :title="$t('进行中的项目数量')"
            :icon="'icon-jinhangzhongdehuodong'"
          )
        el-col(:span="8")
          dashboard-total-count-card(
            :count="overview.todo_count "
            :title="$t('待处理的任务数量')"
            :icon="'icon-daichulirenwu'"
          )
    .campaign-dashboard__taskCard__container
      task-table(
        v-if="showAssignTable"
        :taskType="0"
        :key="'assign_table'"
        @shouldhideTaskTable="shouldhideTaskTable"
      )
    .campaign-dashboard__taskCard__container
      task-table(
        v-if="showCopyTable"
        :taskType="1"
        :key="'copy_table'"
        @shouldhideTaskTable="shouldhideTaskTable"
      )
    open-task-container(
      :title="$t('进行中的全流程项目')"
      :campaignType="'normal'"
      :key="'normal_campaign'"
    )
    open-task-container(
      :title="$t('进行中的媒体投放项目')"
      :campaignType="'ec'"
      :key="'ec_campaign'"
    )
    open-task-container(
      :title="$t('进行中的快捷项目')"
      :campaignType="'lite'"
      :key="'lite_campaign'"
    )
    open-task-container(
      :title="$t('进行中的明星项目')"
      :campaignType="'star'"
      :key="'unistar_campaign'"
    )
</template>

<script>
import TaskTable from './components/TaskTable'
import TaskTable2 from './components/TaskTable2'
import axios from 'axios'
import OpenTaskContainer from './components/OpenTaskContainer'
import DashboardTotalCountCard from './components/DashboardTotalCountCard'

const getDashboardOverview = () => {
  return axios.get('/dashboard/getDashboardOverview')
}

export default {
  components: {
    DashboardTotalCountCard,
    TaskTable,
    TaskTable2,
    OpenTaskContainer
  },
  data () {
    return {
      loading: true,
      overview: {},
      showAssignTable: true,
      showCopyTable: true
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      try {
        this.overview = await getDashboardOverview()
        this.loading = false
      } catch (err) {
        this.loading = false
        throw new Error(err)
      }
    },
    shouldhideTaskTable (value, type) {
      if (type === 0) {
        this.showAssignTable = value
      } else if (type === 1) {
        this.showCopyTable = value
      }
    }
  }
}
</script>

<style lang="stylus">
.campaign-dashboard
  .el-row
    margin 24px 0

.campaign-dashboard__list-summary-container
  .el-card
    .el-card__body
      padding 0
      .icon-container
        height: 67px;
        background: $main;
        display: flex;
        width: 67px;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        margin-right: 22px;
        .iconfont
          color #ffffff
          font-size 48px

.campaign-dashboard__taskCard__container
  .el-card
    .el-card__body
      padding 0 !important

.campaign-dashboard__taskCard__title
  position relative
  display flex
  align-items center
  >.el-radio-group
      position absolute
      right 0
      .el-radio-button__inner
        padding 5px 15px

  > div
    > span
        font-size 16px
  > span
      margin-left 10px
      font-size 16px
.task_count_container
  width 20px
  height 20px
  background #e1ebfd
  border 1px solid #cbddf9
  border-radius 50%
  display flex
  align-items center
  justify-content center
.task_count
  color $main
  font-size 14px
.dashboard-module__title
  margin 40px 0 27px
  display flex
  align-items center
  justify-content space-between
  > div
    &:first-child
      display flex
      align-items center
      > span
        &:nth-child(2)
          font-size 18px
          margin 0 8px
          color #2c3031
          font-weight 500
        &:nth-child(3)
          font-size 16px
.task-table_type
  display flex
  align-items center
  div
    cursor pointer
    display flex
    align-items center
    border 1px solid #E1EBFD
    height 28px
    border-radius 13.5px
    background-color: #ffffff
    padding 5px 4px
    box-sizing border-box
    min-width 116px
    &:nth-child(2)
      margin-left 12px
    > span
      &:nth-child(1)
        margin-left auto
      &:nth-child(2)
        margin-left 16px
    &.active
      border-color $main
      box-shadow 0 0 12px 0 #A5C2F1
      > span
        &:nth-child(1)
          color $main
          font-weight bold
</style>
